(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("replies-to", [], factory);
	else if(typeof exports === 'object')
		exports["replies-to"] = factory();
	else
		root["replies-to"] = factory();
})(window, function() {
return 